import { render, staticRenderFns } from "./innovationServiceNew.vue?vue&type=template&id=fa7ec9e8&scoped=true"
import script from "./innovationServiceNew.vue?vue&type=script&lang=js"
export * from "./innovationServiceNew.vue?vue&type=script&lang=js"
import style0 from "./innovationServiceNew.vue?vue&type=style&index=0&id=fa7ec9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7ec9e8",
  null
  
)

export default component.exports